import { render, staticRenderFns } from "./VLeaseAttachmentsModal.vue?vue&type=template&id=d87adf5a&"
import script from "./VLeaseAttachmentsModal.vue?vue&type=script&lang=js&"
export * from "./VLeaseAttachmentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports